/* eslint-disable security/detect-unsafe-regex */
/* eslint-disable max-len */
import { Menu } from '@headlessui/react'
import React, { useState } from 'react';
import 'react-loading-skeleton/dist/skeleton.css'
import { Link, useLocation, useNavigate , useParams} from 'react-router-dom';
import { dataService } from '../../../services/dataService';
import PublishAuctionModal from './publishAuctionModal';
import config from '../../../config';
import { Auth } from 'aws-amplify';
import { logout } from '../../auth/registrationSlice';
import { useDispatch } from 'react-redux';
import { clearData } from '../../account/profileSlice';
import { getAuctionStatusClasses } from '../../../constant/auctionStatusClasses';
import scrollToTop from '../../../CommonComponent/scrollToTop';
import Modal from '../../../CommonComponent/Modal';

export default function Header({auctionData, cloneHandler, lotInfo, handleView, domain, bidInformation, lots,setMessage, setUploadErrorMessage}){
    const state = useLocation();
    const {id, uid} = useParams();
    const Navigate=useNavigate();
    const [isDeleteModalOpen,setIsDeleteModalOpen] = useState(false)
    const [isCancelModalOpen,setIsCancelModalOpen] = useState(false)
    const [loader, setLoader] = useState(false)
    const [publishModalOpen, setPublishModalOpen] = useState(false);
    const [unpublishModalOpen,setUnpublishModalOpen]= useState(false); 
    const [publishLoader,setPublishLoader] = useState(false)
    const [isRequiredFieldEmpty, setIsRequiredFieldEmpty] = useState(false)
    const [notConnect, setNotConnect]=useState(null)
    const [isPublished, setIsPublished] = useState(false)
    const user = (localStorage.getItem('user'));
    const [noLot,setNoLot]=useState(false);
    const dispatch = useDispatch()
    const plan_type=localStorage.getItem('plan_type');

    /**
     * The function `handleDelete` is an asynchronous function that deletes an auction and updates the
     * state and local storage accordingly.
     */
    const handleDelete = async()=>{
        setLoader(true)
        const data = await dataService.DeleteAuction(auctionData.auction_id)
        if(data.error===false){
            setLoader(false)
            setIsDeleteModalOpen(false)
            Navigate('/auctions')
            localStorage.setItem('AuctionDelete', 'success');
        }
    }
    
    const handleCancel = async()=>{
        setLoader(true)
        const body={
            "type": "CANCEL"
        }
        const response = await dataService.UnpublishAuction(auctionData.auction_id,body);
        if(response.error===true){
            setIsCancelModalOpen(false)
            setMessage('Auction is already in cancelled');
            setTimeout(() => {
                setMessage('')
            }, 4000);
            handleView()
        }
        else{
            setLoader(false)
            setIsCancelModalOpen(false)
            setMessage('Auction cancelled successfully');
            setTimeout(() => {
                setMessage('')
            }, 4000);
            handleView()
        }
    }

    /**
     * The function `handlePublishAuction` is an asynchronous function that publishes an auction and
     * updates the state accordingly.
     */
    const handlePublishAuction = async(auctionId)=>{
        setPublishLoader(true)

        const body = {
            "email": user
        }
        if(!((auctionData.auction_image =="" || auctionData.title=="" || auctionData.description=="" || auctionData.currency=="" ) || 
            (auctionData.start_date =="" || auctionData.end_date=="" || (auctionData.time_zone=="" ) || auctionData.start_date ==null || auctionData.end_date==null ) || 
            (((auctionData.extension_type =="Cascade" || auctionData.extension_type =="Individual lots") 
            && auctionData.extension_time_between_lots=="") || auctionData.extension_time=="" || auctionData.registration_type=="" 
            || ((auctionData.add_buyer_fees =="Add percentage"  && auctionData.percentage=="") || ( auctionData.add_buyer_fees=="Add fixed fee" 
            && auctionData.fees=="" ) ))) ){
            
            if(lots.length>0){
                const data = await dataService.publishAuction(auctionId)
                if(data.error==true){
                    const errorMessage = data.message.response.data.message;

                    switch (errorMessage) {
                    case "Auction is already published or is Accepting bids":
                        setUploadErrorMessage("Auction is already in Published State");
                        setPublishModalOpen(false);
                        handleView();
                        setTimeout(() => {
                            setUploadErrorMessage("");
                        }, 3000);
                        break;

                    case "Some lots are missing lot images":
                        setPublishModalOpen(false);
                        setIsRequiredFieldEmpty(true);
                        setNoLot(true);
                        break;

                    case "Stripe or PayPal account is not linked.":
                        setNotConnect("stripe");
                        setPublishModalOpen(false);
                        setIsRequiredFieldEmpty(true);
                        break;

                    case "Unauthorised to perform this action.":
                        Auth.signOut();
                        dispatch(logout());
                        dispatch(clearData());
                        localStorage.clear();
                        Navigate("/login");
                        break;

                    default:
                        if (errorMessage.includes("verification")) {
                            setNotConnect("verification");
                            setPublishModalOpen(false);
                            setIsRequiredFieldEmpty(true);
                        } else {
                            setUploadErrorMessage(errorMessage);
                            setPublishModalOpen(false);
                            setTimeout(() => {
                                setUploadErrorMessage("");
                            }, 30000);
                        }
                        break;
                    }

                }else{
                    setUploadErrorMessage("")
                    setIsPublished(true)
                    setPublishModalOpen(false)
                    setPublishLoader(false)
                    handleView()
                }
            }else{
                setPublishModalOpen(false)
                setIsRequiredFieldEmpty(true)
            }
        }else{
            setPublishModalOpen(false)
            setIsRequiredFieldEmpty(true)
        }

        setPublishLoader(false)
    }

    const handleTemplate=(template)=>{
        if(template==="Classic"){
            localStorage.setItem('selectedTemplateId','1')
            return "classic";
        }else if(template==="" || template==="Single lot" || template==="Single Lot"){
            localStorage.setItem('selectedTemplateId','2')
            return "single-lot";
        }else if(template==="Standalone"){
            localStorage.setItem('selectedTemplateId','3')
            return "standalone";
        }
    }
    
    const handleUnpublishAuction = async()=> {
        setPublishLoader(true)
        const body={
            "type": "UNPUBLISH"
        }
        const data = await dataService.UnpublishAuction(auctionData.auction_id, body)
        setUnpublishModalOpen(false)
        setPublishLoader(false)
        scrollToTop();
        if(data.error==true){
            if(data?.message?.response?.data?.message){
                setUploadErrorMessage(data?.message?.response?.data?.message)
                setTimeout(()=>{
                    setUploadErrorMessage("")
                },30000)
            }else{
                setUploadErrorMessage('Something went wrong. Please try again')
                setTimeout(()=>{
                    setUploadErrorMessage("")
                },3000)
            }
        }else{
            setUploadErrorMessage('');
            setMessage('Auction unpublished successfully')
            setTimeout(()=>{
                setMessage("")
            },3000)
        }
        handleView()
    }


    return(
        <>
            <div className="flex justify-between items-center mt-8 sm:flex-row flex-col">
                <div className='sm:w-auto w-full'>
                    <div data-testid="status" 
                        className={`flex gap-1 justify-center min-w-[96px] w-fit relative py-[8px] mb-3 px-[16px] text-[12px] 
                            ${getAuctionStatusClasses(auctionData.status)} 
                            rounded-[42px] text-end leading-normal font-semibold`}>
                        {auctionData.status==='Accepting bids' &&
                            <img className="" src="/images/green-dot.svg" alt="img" />}
                        {auctionData.status}
                    </div>
                    
                    <p id="auction-title" 
                        title={auctionData.title}
                        className="sm:text-[34px] text-[20px]  font-medium leading-normal text-[#343434] sm:pt-0 pt-3.5">
                        {auctionData.title===''?'Auction title goes here': (auctionData?.title?.length > 50 ? auctionData?.title?.substring(0, 50) + '...' : auctionData?.title) }</p>
                </div>
                <div className="flex sm:mt-0 mt-3 sm:w-auto w-full sm:justify-start justify-end gap-3">
                    {(auctionData.status!=='Cancelled' ) && 
                        <>
                            {(auctionData.status==='Published' || auctionData.status=== 'Completed' || auctionData.status === "Accepting Bids" || auctionData.status === "Accepting bids") &&
                            <Link type='button' target='_blank' data-testid="view_preview" to={`https://${domain}.${config.Environment.domain}/auctions/${auctionData._id}?isPreview=true`}
                                className="px-5 py-[12px] bg-[#FFFFFF] text-[#52525A] w-[129px]
                leading-normal border border-[rgb(161,161,169)] font-medium text-[14px] rounded-[6px] hover:bg-[#A1A1A9] hover:text-[#FFFFFF]">
                                View Auction
                            </Link>
                            }
                            {(auctionData.status=='Accepting bids' || auctionData.status=='Draft' || auctionData.status=='Published') && 
                            <button id='edit-auction' type='button'
                                onClick={()=>{
                                    Navigate(`/auctions/timed/edit/${id}/${uid}/${handleTemplate(auctionData?.template_name)}`,
                                        {state: auctionData===undefined? '' : {start_date: auctionData.start_date, end_date: auctionData.first_lot_end_date, location: auctionData.location }})
                                }} 
                                className="px-5 py-[12px] bg-[#FFFFFF] text-[#52525A] w-[67px]
                    leading-normal border border-[#A1A1A9] font-medium text-[14px] rounded-[6px] hover:bg-[#A1A1A9] hover:text-[#FFFFFF]">
                                Edit
                            </button>}
                        
                            {auctionData.status!=='Published' && auctionData.status!=='Accepting bids' && auctionData.status!=='Completed' &&
                            <button data-testid="publish-auction" 
                                className="sx:px-[31px] px-5 py-[12px] bg-[#282828] mr-2 text-[#FFFFFF] hover:bg-[#3F3F45]
                    leading-normal font-medium text-[14px] rounded-[6px]"  onClick={() => {
                                    auctionData.status==='Published' ? setUnpublishModalOpen(true) : setPublishModalOpen(true)
                                }}>
                                Publish
                            </button> }
                        </>
                    }
                    <Menu as="div" className="flex items-center relative " id="menu_id">
                        <Menu.Button className="relative" data-testid="menu_id" data-te-dropdown-ref>
                            <img src="/images/three-dots-icon-black.svg" alt="img" className="cursor-pointer"   type="button"
                                id="dropdownMenuButton1"
                                data-te-dropdown-toggle-ref
                                aria-expanded="false"/>
                        </Menu.Button>
                        <Menu.Items 
                            className="absolute top-[50px] right-0 z-50 float-left m-0 w-[145px] py-2 min-w-max list-none 
                            overflow-hidden px-2
                                rounded-[10px] border-none bg-white bg-clip-padding text-left text-base shadow-bs3 
                                [&[data-te-dropdown-show]]:block"
                            aria-labelledby="dropdownMenuButton2">
                            {(auctionData.status!=="Accepting bids" && auctionData.status!=="Cancelled") && <Menu.Item>
                                <button onClick={()=>{cloneHandler()}}
                                    disabled={plan_type.includes("Free")}
                                    className="disabled:text-[hsl(240,4%,65%)] disabled:cursor-auto block 
                                                        w-full whitespace-nowrap bg-transparent pl-3 pr-5 text-left hover:bg-[#E6E6E6] hover:rounded-[11px]
                                                            py-2 text-[12px] font-medium text-[#343434] cursor-pointer"
                                >Clone</button>
                            </Menu.Item> }        
                            {auctionData.status==='Published'&&
                                <Menu.Item>
                                    <a data-testid="publish-auction"
                                        className="cursor-pointer block w-full whitespace-nowrap bg-transparent pl-3 pr-5 
                                    py-1.5 text-[12px] hover:bg-[#E6E6E6] hover:rounded-[11px]
                                        font-medium text-[#343434]"
                                        onClick={() => {
                                            auctionData.status==='Published' ? setUnpublishModalOpen(true) : setPublishModalOpen(true)
                                        }}
                                    >Unpublish</a>
                                </Menu.Item>}  
                            {auctionData.status!=='Accepting bids' && auctionData.status!=='Completed' &&
                                <Menu.Item>
                                    <button type='button' 
                                        disabled={auctionData.status==="Accepting Bids" || 
                                    auctionData.status==='Completed'}
                                        data-testid="delete-auction"
                                        onClick={()=>{setIsDeleteModalOpen(true)}}
                                        className="cursor-pointer block w-full whitespace-nowrap bg-transparent pl-3 pr-5 
                                    py-1.5 text-[12px] text-left hover:bg-[#E6E6E6] hover:rounded-[11px]
                                        font-medium text-[#343434]"
                                    >Delete</button>
                                </Menu.Item>}  
                            {auctionData.status==='Accepting bids' && 
                                <Menu.Item>
                                    <button type='button' data-testid="deactivate"
                                        onClick={()=>{setIsCancelModalOpen(true)}}
                                        className="cursor-pointer block w-full whitespace-nowrap bg-transparent pl-3 pr-5 
                                    py-1.5 text-[12px] text-left hover:bg-[#E6E6E6] hover:rounded-[11px]
                                        font-medium text-[#343434]"
                                    >Cancel</button>
                                </Menu.Item>}  
                        </Menu.Items>
                    </Menu>
                </div>
                {/* <!-- box content --> */}
            </div>
            <div className="flex ss:flex-nowrap flex-wrap mt-6">
                <div className="ss:w-1/3 w-full min-h-[99px] lg:px-10 px-5 pt-3 ss:mb-0 mb-2.5 rounded-[20px] bg-[#DDD1D5]">
                    <p className="text-[12px] leading-normal font-semibold text-[#52525A]">SUM OF CURRENT BIDS</p>
                    <p className="xmd:text-[30px] md:text-[20px] text-[30px] lg:text-[34px] leading-normal font-bold text-[#282828] truncate"
                        title={bidInformation.sum_of_current_bids ? 
                            Number(bidInformation.sum_of_current_bids).toLocaleString(auctionData.currency ==='INR' ? 'en-IN' : 'en-US', {
                                style: 'currency',
                                currency: auctionData.currency,
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            }) : (lotInfo.sum_current_bid!==undefined && (Number(lotInfo.sum_current_bid).toLocaleString(auctionData.currency ==='INR' ? 'en-IN' : 'en-US', {
                                style: 'currency',
                                currency: auctionData.currency,
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            })))}>
                        {bidInformation.sum_of_current_bids ? 
                            Number(bidInformation.sum_of_current_bids).toLocaleString(auctionData.currency ==='INR' ? 'en-IN' : 'en-US', {
                                style: 'currency',
                                currency: auctionData.currency,
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            }) : (lotInfo.sum_current_bid!==undefined && (Number(lotInfo.sum_current_bid).toLocaleString(auctionData.currency ==='INR' ? 'en-IN' : 'en-US', {
                                style: 'currency',
                                currency: auctionData.currency,
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            })))}
                    </p>
                </div>
                <div className=" ss:w-1/3 w-full min-h-[99px] px-5 lg:px-10 pt-3 ss:mx-5 ss:mb-0 mb-2.5 rounded-[20px] bg-[#B8D5DB]">
                    <p className="text-[12px] leading-normal font-semibold text-[#52525A]">NUMBER OF ACTIVE BIDDERS</p>
                    <p className="text-[30px] lg:text-[34px] leading-normal font-bold text-[#282828]">
                        {bidInformation.number_of_bids ? bidInformation.number_of_bids : (lotInfo.number_of_bids)}</p>
                </div>
                <div className="ss:w-1/3 w-full min-h-[99px] px-5 lg:px-10 pt-3 rounded-[20px] ss:mb-0 mb-2.5 bg-[#ECD6C7]">
                    <p className="text-[12px] leading-normal font-semibold text-[#52525A]">TOTAL SELLING</p>
                    <p className="text-[30px] lg:text-[34px] leading-normal font-bold text-[#282828]">{bidInformation.current_bidding_lot ? bidInformation.current_bidding_lot : (lotInfo["total selling"] ? lotInfo["total selling"] : "0")}
                        <span className='lg:text-[23px] text-[18px] ' > {bidInformation.total_selling ? `(${Number(bidInformation.total_selling).toFixed(2)}%)` : (lotInfo["total selling"] ? `(${(Number(lotInfo["total selling"]) / Number(lotInfo.total_lots) * 100).toFixed(2)}%)` : "" )}</span></p>
                </div>
            </div>

            <Modal setIsOpen={setIsDeleteModalOpen} isOpen={isDeleteModalOpen} handleAction={handleDelete} loading={loader} 
                buttonText="Delete" id="delete-button" close={false} notShowCancel={false}
                title="Are you sure you want to delete the auction?"
                description="Please note that deleting the auction will also delete all lots within the auction. This action cannot be reversed."
            />
            {(publishModalOpen || isRequiredFieldEmpty || isPublished) && 
            <PublishAuctionModal notConnect={notConnect} publishModalOpen={publishModalOpen} setPublishModalOpen={setPublishModalOpen} 
                handlePublishAuction={handlePublishAuction} loader={publishLoader} selectedId={auctionData.auction_id}
                auctionData={auctionData} isRequiredFieldEmpty={isRequiredFieldEmpty} domain={domain} noLot={noLot}
                setIsRequiredFieldEmpty={setIsRequiredFieldEmpty} isPublished={isPublished} setIsPublished={setIsPublished} />}

            <Modal setIsOpen={setIsCancelModalOpen} isOpen={isCancelModalOpen} handleAction={handleCancel} loading={loader} 
                buttonText="Cancel auction" id="cancel-button" close={true} notShowCancel={true}
                title="Are you sure you want to cancel the auction?"
                description="Please note that cancelled auctions cannot be re-published. All bidder and bids data will be retained."
            />

            <Modal isOpen={unpublishModalOpen} setIsOpen={setUnpublishModalOpen} loading={publishLoader}
                title="Are you sure you want to unpublish this auction?" close={true} 
                handleAction={handleUnpublishAuction} buttonText="Unpublish" testid="unpublish"
            />

        </>
    );
}